import React from "react";
import Navbar from "../src/components/Navbar";
import LinearStepper from "./components/LinearStepper";
import Footer from "../src/components/Footer";
import Baner from "../src/components/Baner"
import './styles/tags.scss';
import { Container } from "react-bootstrap";

import "./styles/App.scss";

function App() {
  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <LinearStepper />
          </div>
          <div className="col-lg-3">
            <Baner />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
